import type { ImportMapping } from "@/types/data-import.types";
import type { LineChain } from "@/types/line-chains.types";

/**
 * Spec 084 — os pares que a regra de origem pode usar: ligados DIRETAMENTE na cadeia e com as duas
 * linhas registradas por alguma coluna deste arquivo.
 *
 * As duas condições são as mesmas que a rota confere. Oferecer aqui o que ela recusa faria o gestor
 * montar o mapeamento inteiro para descobrir no fim que a ligação não vale.
 */
export function directPairsOf(
  chains: LineChain[],
  mapping: ImportMapping
): Array<{ upstreamLineId: string; downstreamLineId: string }> {
  const mapeadas = new Set(
    Object.values(mapping).flatMap((d) =>
      d.action === "MAP" ? d.targets.map((t) => t.lineId) : []
    )
  );
  const out: Array<{ upstreamLineId: string; downstreamLineId: string }> = [];
  for (const chain of chains) {
    // As LIGAÇÕES da etapa, nunca a vizinhança na lista. As etapas vêm em ordem topológica, e nela
    // duas vizinhas podem não ter ligação alguma (fan-in: duas linhas de nível 0 lado a lado) e uma
    // ligação real pode pular etapas (a linha de nível 0 que alimenta só a última). Inferir da
    // ordem oferecia par que a rota recusa com 422 e escondia par que o gestor precisa declarar.
    for (const stage of chain.stages) {
      if (!mapeadas.has(stage.lineId)) continue;
      for (const upstreamLineId of stage.upstreamLineIds) {
        if (!mapeadas.has(upstreamLineId)) continue;
        out.push({ upstreamLineId, downstreamLineId: stage.lineId });
      }
    }
  }
  return out;
}
